import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { saasApi, type SaaSTenant } from '../../api/saas';

export function ProvisioningCenterPage() {
  const [tenants, setTenants] = useState<SaaSTenant[]>([]);
  const [result, setResult] = useState('');
  const [error, setError] = useState('');

  useEffect(() => { void saasApi.tenants().then(setTenants).catch((e) => setError(String(e))); }, []);

  const provision = async (id: string) => {
    try {
      const r = await saasApi.provision(id);
      setResult(`Provisioned ${id}: ${r.steps.length} steps, schema ${r.schema_name}`);
    } catch (e) {
      setError(String(e));
    }
  };

  return (
    <div className="mx-auto max-w-4xl p-6">
      <Link to="/saas" className="text-sm text-slate-600 hover:underline dark:text-slate-400">← Global SaaS Dashboard</Link>
      <h1 className="mt-2 text-2xl font-semibold">Provisioning Center</h1>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      {result && <p className="mt-4 text-sm text-green-600">{result}</p>}
      <ul className="mt-4 divide-y rounded-lg border dark:border-slate-700">
        {tenants.filter((t) => !t.provisioned_at).map((t) => (
          <li key={t.id} className="flex items-center justify-between px-4 py-3 text-sm">
            <span>{t.name} <span className="text-slate-500">({t.status})</span></span>
            <button type="button" className="text-blue-600 hover:underline" onClick={() => void provision(t.id)}>Provision</button>
          </li>
        ))}
        {tenants.every((t) => t.provisioned_at) && <li className="px-4 py-6 text-center text-slate-500">All tenants provisioned</li>}
      </ul>
    </div>
  );
}
